import { render, staticRenderFns } from "./priceStrategyAction.vue?vue&type=template&id=753c4f8c"
import script from "./priceStrategyAction.vue?vue&type=script&lang=js"
export * from "./priceStrategyAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports